/**
 * Environment Configuration
 * Gateway-only mode for Dev Admin panel
 */

export const ENV = {
  // API
  API_URL: import.meta.env.VITE_API_URL,

  // App
  APP_NAME: import.meta.env.VITE_APP_NAME,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,

  // Feature flags
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,

  // Deployed environment identifier (development | staging | production) --
  // drives non-prod tooling such as the BugPin widget, which loads on
  // development and staging (AXF-913). Defaults to production.
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT ?? 'production',

  // Gateway BFF Configuration (always gateway mode)
  GATEWAY_URL: import.meta.env.VITE_GATEWAY_URL?.replace(/\/$/, ''),

  // AXF-1013: where "Back to AX WorkFlow" and "Open AX WorkFlow" point. The portal has no sign-in
  // of its own, so these two buttons are the only way out of the refusal and resting pages.
  // Empty when unset — the pages then render their text with no button, never a dead one (R12).
  APP_URL: import.meta.env.VITE_APP_URL?.replace(/\/$/, '') ?? '',
} as const
